import { NormalizeOAS, OASRequestParams, OASResponse } from 'fets';
import type assetLibraryOpenApi from '../asset-library-open-api';
import { AssetLibraryFetsApiClient } from '../asset-library-fets-client';
import { assertNever } from '../utils';
import { Guid } from '../../api/public/utils/Guid';

const PATH = '/api/v2/asset/company/{companyId}/archive';

type Params = {
  companyId: Guid;
  assetIds: Guid[];
};

type Result = { assetIds: Guid[] };

export type ApiFunction = (params: Params, signal?: AbortSignal) => Promise<Result>;

export const createArchiveAssets = (apiClient: AssetLibraryFetsApiClient): ApiFunction => {
  const archiveAssets = async (params: Params, signal?: AbortSignal): Promise<Result> => {
    const response = await apiClient[PATH].post({
      ...convertToRequest(params),
      ...(signal && { signal }),
    });

    return convertResponse(response);
  };

  return archiveAssets;
};

type Request = OASRequestParams<NormalizeOAS<typeof assetLibraryOpenApi>, typeof PATH, 'post'>;
type Response = OASResponse<NormalizeOAS<typeof assetLibraryOpenApi>, typeof PATH, 'post'>;

const convertToRequest = (params: Params): Request => ({
  params: { companyId: params.companyId },
  json: { assetIds: params.assetIds },
});

const convertResponse = async (response: Response): Promise<Result> => {
  const responseStatus = response.status;
  if (responseStatus !== 200) {
    return assertNever(responseStatus);
  }

  const data = await response.json();
  return { assetIds: data.assetIds };
};
